export const FF_CSL = process.env.REACT_APP_FF_CSL === "true";
export const FF_INTERMEDIARIES = process.env.REACT_APP_FF_INTERMEDIARIES === "true";
export const FF_HEALTHCARD = process.env.REACT_APP_FF_HEALTHCARD === "true";
export const FF_FUNERAL_ATECO = process.env.REACT_APP_FF_FUNERAL_ATECO === "true";
export const FF_BANKCODES = process.env.REACT_APP_FF_BANKCODES === "true";
export const FF_DEMO = process.env.REACT_APP_FF_DEMO === "true";
